import { Link } from "react-router-dom";

/**
 * Twilio-compliant SMS consent checkbox.
 * Renders the exact opt-in language required for A2P 10DLC / carrier approval.
 *
 * Props:
 *  - checked: boolean
 *  - onChange: (bool) => void
 *  - accent: "neon" | "electric"  (matches page brand color)
 *  - testId: string
 */
export default function SmsConsentCheckbox({ checked, onChange, accent = "neon", testId = "sms-consent" }) {
  const accentClasses =
    accent === "electric"
      ? "accent-ih-electric text-ih-electric focus:ring-ih-electric"
      : "accent-ih-neon text-ih-neon focus:ring-ih-neon";
  const linkAccent = accent === "electric" ? "text-ih-electric" : "text-ih-neon";

  return (
    <label
      htmlFor={testId}
      className="flex items-start gap-3 rounded-2xl border border-ih-line2 bg-black/30 p-4 cursor-pointer hover:border-white/20 transition"
    >
      <input
        id={testId}
        type="checkbox"
        data-testid={testId}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={`mt-0.5 h-4 w-4 rounded border border-ih-line2 bg-black ${accentClasses}`}
      />
      <span className="text-xs leading-relaxed text-white/70">
        <span className="block text-white/90 font-semibold mb-1">
          SMS updates (optional)
        </span>
        By checking this box, I agree to receive automated transactional SMS
        notifications from IslandHop Technologies LLC at the number provided.
        Message frequency varies. Message and data rates may apply. Reply STOP
        to unsubscribe, HELP for help. View our{" "}
        <Link
          to="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testId}-privacy-link`}
          className={`${linkAccent} underline underline-offset-2 hover:opacity-80`}
        >
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link
          to="/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testId}-terms-link`}
          className={`${linkAccent} underline underline-offset-2 hover:opacity-80`}
        >
          Terms
        </Link>
        .
      </span>
    </label>
  );
}
